module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('el-button', {
    staticClass: "float-right",
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'devices'
      }
    }
  }, [_vm._v("Devices")])], 1)])], 1), _vm._v(" "), _c('section', {
    staticClass: "content device-content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "search-wrapper panel-heading col-sm-12"
  }, [_c('form', {
    staticClass: "device-search-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchData($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search by serial, name, ICC Id, customer..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchData($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activityFilter),
      expression: "activityFilter"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activityFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.applyGlobalFilters]
    }
  }, [_c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v("All devices")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACTIVE"
    }
  }, [_vm._v("Online devices")])]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "row-click": _vm.onRowClick
    }
  }, [_c('template', {
    slot: "empty"
  }, [_vm._v("Loading...")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": 10
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.isDeviceOnline(scope.row.serial) ?
              'Online' :
              'Offline',
            "placement": "left"
          }
        }, [_c('OnlineStatus', {
          attrs: {
            "status": _vm.isDeviceOnline(scope.row.serial)
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serial",
      "label": "Serial",
      "min-width": 15
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "min-width": 30
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "iccId",
      "label": "ICC Id",
      "min-width": 15
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "Created",
      "min-width": 30
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Last Online",
      "min-width": 30
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.formatLastActive(scope.row)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customer.name",
      "label": "Customer",
      "min-width": 40
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-row', {
          staticClass: "device-actions-row"
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Make snapshot",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          staticClass: "btn-rounded",
          attrs: {
            "type": "default",
            "icon": "el-icon-picture",
            "circle": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.currentDevice = scope.row;
              _vm.snapshotVisible = true;
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Xml File",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          staticClass: "btn-rounded",
          attrs: {
            "type": "default",
            "icon": "el-icon-tickets",
            "circle": ""
          },
          on: {
            "click": [function($event) {
              return _vm.getXml(scope.row)
            }, function($event) {
              $event.stopPropagation();
              _vm.xmlVisible = true;
              _vm.currentDevice = scope.row;
              _vm.currentRow = scope.row.serial;
            }]
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Historical lookup",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          staticClass: "btn-rounded",
          attrs: {
            "type": "info",
            "icon": "el-icon-date",
            "circle": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.currentDevice = scope.row;
              _vm.videoSearchVisible = true;
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Live stream",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          staticClass: "btn-rounded",
          attrs: {
            "type": "danger",
            "icon": "el-icon-caret-right",
            "circle": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.currentDevice = scope.row;
              _vm.liveStreamVisible = true;
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Edit",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          staticClass: "btn-rounded",
          attrs: {
            "type": "primary",
            "icon": "el-icon-edit",
            "circle": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.handleEdit(scope.row)
            }
          }
        })], 1), _vm._v(" "), [(scope.row.disabled) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Restore",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          staticClass: "btn-rounded",
          attrs: {
            "type": "success",
            "icon": "el-icon-refresh",
            "circle": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.handleRestore(scope.row)
            }
          }
        })], 1) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Delete",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          staticClass: "btn-rounded",
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "circle": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.handleDelete(scope.row)
            }
          }
        })], 1)]], 2)]
      }
    }])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagination.pageSize,
      "layout": "prev, pager, next, sizes",
      "total": _vm.tableTotal,
      "page-sizes": _vm.pagination.rowsPerPageItems,
      "current-page": _vm.pagination.pageNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), _c('VideoSearchDialog', {
    attrs: {
      "device": _vm.currentDevice,
      "visible": _vm.videoSearchVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.videoSearchVisible = $event
      }
    }
  }), _vm._v(" "), _c('LiveStreamDialog', {
    attrs: {
      "device": _vm.currentDevice,
      "visible": _vm.liveStreamVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.liveStreamVisible = $event
      }
    }
  }), _vm._v(" "), _c('SnapshotDialog', {
    attrs: {
      "device": _vm.currentDevice,
      "visible": _vm.snapshotVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.snapshotVisible = $event
      }
    }
  }), _vm._v(" "), _c('XmlDialog', {
    attrs: {
      "visible": _vm.xmlVisible,
      "device": _vm.currentDevice,
      "serial": _vm.currentRow,
      "xmlData": _vm.xmlData,
      "isSuccessful": _vm.isSuccessful,
      "isLoading": _vm.isLoading,
      "hasError": _vm.hasError
    },
    on: {
      "update:visible": function($event) {
        _vm.xmlVisible = $event
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42b31dc6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/devices/Index.vue
// module id = 1150
// module chunks = 2